import { SxProps } from "@mui/material";

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    '@media (max-width: 1130px) and (max-height: 600px)': {
        marginLeft: '20px' 
    }
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '30%',
    minWidth: '250px',
    maxHeight: '100vh',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px 48px',
    gap: '24px',
    overflow: 'auto'
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px '
}

export const sxTryAgainButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px ',
    backgroundColor: '#FFF'
}

export const sxButtonCameraCapture: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 768px)': {
        width:'90%',
    }
}

export const sxTypographyCameraCapture: SxProps = {
    color: 'var(--Grey-Light-White, #FFF)',
    textAlign: 'center',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    width: '30%',
    fontWeight: 700,
    lineHeight: '150%',
    '@media (max-width: 767px)': {
        width: '80%'
    },
    position: 'absolute',
    bottom: '5%',
    zIndex: '1'
}